<ngx-loading [show]="loading"></ngx-loading>
<div class="card receipt shadow min-vh-100" id="pdf-content">
    <div class="d-flex justify-content-center align-items-center receipt-img">
        <img *ngIf="merchantLink === 'bd8kl9r652'; else brandImage" class="img-fluid w-30 mt-5" src="{{ cart?.merchant?.imageURL }}" />
        <ng-template #brandImage>
            <img class="img-fluid w-30" src="{{ cart?.merchant?.brand?.photoURL }}" />
        </ng-template>
    </div>
    <div class="card-body">

        <div class="text-center h6">
            <div class="h5">{{ cart?.merchant?.businessName }}</div>
            <div>{{ cart?.merchant?.address }}</div>
            <div class="mt-1">VAT No: {{ cart?.merchant?.vatNumber }}</div>
        </div>
        <div >
            <h3 class="mt-3 text-center">
                #{{ cart?.id }}
            </h3>
            <h5 class="text-center">Digital Check</h5>
            <div class="float-right">
                {{ cart?.saleUnitCarts[0]?.merchantSaleUnit?.identifier ? 'Table: ' +
                cart?.saleUnitCarts[0]?.merchantSaleUnit?.identifier?.toString() : '' }}</div>
        </div>
        <br />
        <div class="row mt-1 pt-2 pb-2 receipt-rounded-top-element">
            <div class="col-auto text-light font-weight-semibold">{{ cart?.applicationSource?.name }}</div>
        </div>
        <div class="mt-3 text-left">
<!--            <div>Guests: {{ cart?.saleUnitCarts[0]?.noPersons }}</div>-->
            <div>Date: {{ cart?.createdDate | date:"dd MMM yyyy HH:mm" }}</div>
        </div>

        <div class="mt-4 receipt-dotted-separator"></div>

        <div *ngFor="let cartProduct of cart?.cartProducts;">
            <div *ngIf="!cartProduct?.isVoid && !cartProduct?.saleUnitCartSplitId" class="row mt-2 pt-2">
                <div class="col-auto">{{ cartProduct?.quantity }}</div>
                <div class="col">
                    {{ cartProduct?.printName }}
                    <div *ngFor="let group of cartProduct?.groups;">
                        <div *ngFor="let modifier of group.modifiers" class="modifier-item">
                            <div class="d-flex flex-row justify-content-between">
                                <div class="col-auto text-left">{{ '- ' + modifier?.modifierName }}</div>
                                <div class="col-sm-4 text-right mr-n3">
                                    {{ modifier?.price
                                    ? cart?.merchant?.currency?.symbol +
                                    (cartProduct?.quantity * modifier?.price | number : '1.2-2')
                                    : '' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    {{ cart?.merchant?.currency?.symbol + (cartProduct?.quantity * cartProduct?.basePrice | number : '1.2-2') }}
                </div>
            </div>
        </div>

        <div *ngIf="cart?.saleUnitCarts[0]?.discountTypeAmount || cart?.saleUnitCarts[0]?.serviceChargeAmount || cart?.saleUnitCarts[0]?.processingFeeAmount || totalDrs"
            class="mt-3 text-right">

            <div class="d-flex justify-content-between" *ngIf="cart?.saleUnitCarts[0]?.discountTypeAmount">
                <span>Discount Amount:</span>
                <span>- {{ cart?.merchant?.currency?.symbol }}{{ cart?.saleUnitCarts[0]?.discountTypeAmount | number : '1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="cart?.saleUnitCarts[0]?.serviceChargeAmount">
                <span>Service Charge:</span>
                <span>{{ cart?.merchant?.currency?.symbol }}{{ cart?.saleUnitCarts[0]?.serviceChargeAmount | number : '1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="totalDrs">
                <span>Deposit Return Scheme:</span>
                <span>{{ cart?.merchant?.currency?.symbol }}{{ totalDrs | number : '1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="cart?.deliveryFee">
                <span>Delivery Fee:</span>
                <span>{{ cart?.merchant?.currency?.symbol }}{{ cart?.deliveryFee | number : '1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="cart?.saleUnitCarts[0]?.processingFeeAmount">
                <span>Service Fee:</span>
                <span>{{ cart?.merchant?.currency?.symbol }}{{ cart?.saleUnitCarts[0]?.processingFeeAmount | number : '1.2-2' }}</span>
            </div>
            <hr class="mt-1 receipt-thin-separator">
        </div>

        <div class="mt-2 text-right">
            <div class="font-weight-bold">{{
                cart?.cartTotal ? 'Total: ' + cart?.merchant?.currency?.symbol + (cart?.saleUnitCarts[0]?.totalAmount | number :
                '1.2-2')
                : '' }}
            </div>
        </div>
    </div>

    <div class="row align-items-center receipt-footer">
        <div class="col-7">
            <div class="ml-3 mb-1 text-white small">Powered by</div>
            <img class="col-12" src="/assets/img/f-logo.svg"/>
        </div>
        <div class="col-5 d-flex justify-content-end pr-4">
            <a href="https://supersweet.ai/" class="arrow-link text-white" target="_blank">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.2"/>
                    <path d="M25.8115 15.7929L33.668 23.2305C33.88 23.4311 34 23.7091 34 23.9999C34 24.2908 33.88 24.5684 33.668 24.7694L25.8115 32.2069C25.3832 32.6109 24.7053 32.5957 24.2964 32.171C23.8877 31.7504 23.9031 31.0752 24.3327 30.6684L30.2563 25.0637H15.0718C14.4803 25.0637 14 24.5873 14 24.0007C14 23.4141 14.4803 22.9386 15.0718 22.9386H30.2535L24.3299 17.3339C23.9009 16.9263 23.8876 16.2511 24.2938 15.8292C24.7044 15.4042 25.3428 15.3892 25.8115 15.7929Z" fill="white"/>
                </svg>
            </a>
        </div>
    </div>
    <img class="mh-12" src="/assets/img/supersweet-ribbon.png"/>
</div>